import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { getObjectValue } from '../../tools/util';
import Icon from '../../Icon';
import Loading from '../../Loading';
import { hasChildren, ORIGIN, TD_DECORATOR } from '../common';
import ConfigConsumer from '../../ConfigConsumer';
export default function Tree(_ref, _ref2) {
  var mapColumns = _ref.mapColumns,
      dataSource = _ref.dataSource,
      columns = _ref.columns,
      change = _ref.change;
  var childrenColumnName = _ref2.childrenColumnName,
      hasChildrenColumnName = _ref2.hasChildrenColumnName,
      childrenExpandedStateName = _ref2.childrenExpandedStateName;
  var treeEnabled = false;
  var handledDataSource = [];
  var treeLevelMap = new WeakMap(); // level表

  var indentMap = {};

  function traverse() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var level = arguments.length > 1 ? arguments[1] : undefined;
    list.forEach(function (row) {
      var children = getObjectValue(row, childrenColumnName);
      handledDataSource.push(row);
      treeLevelMap.set(row, level); // 如果有children字段。启用树

      if (hasChildren(children) || getObjectValue(row, hasChildrenColumnName)) {
        indentMap[level] = true;
        treeEnabled = true; // 如果展开，递归遍历

        if (getObjectValue(row, childrenExpandedStateName) === true) {
          traverse(children, level + 1);
        }
      }
    });
  }

  traverse(dataSource, 0);

  if (!treeEnabled) {
    return {};
  }

  var treeColumns = columns.filter(function (column) {
    return column.tree;
  });

  if (!treeColumns.length) {
    treeColumns = columns.filter(function (column) {
      return column[ORIGIN];
    }).slice(0, 1);
  }

  var treeColumnsSet = new WeakSet(treeColumns);
  return {
    dataSource: handledDataSource,
    columns: mapColumns(function (column) {
      if (treeColumnsSet.has(column)) {
        return _defineProperty({}, TD_DECORATOR, function (td, row, _ref3) {
          var size = _ref3.size;
          var smallSize = size === 'small' || size === 'mini';
          var iconWidth = smallSize ? 18 : 20; // 图标宽度

          var expandIcon = null; // 展开收起按钮

          var iconIndent = null; // 图标缩进

          var level = treeLevelMap.get(row);
          var expandedState = getObjectValue(row, childrenExpandedStateName); // 缩进

          function Indent(width) {
            return /*#__PURE__*/React.createElement("span", {
              className: "jmtd-table-plugin-tree-indent",
              style: {
                width: width
              }
            });
          } // 如果这层有缩进，添加缩进和图标


          if (indentMap[level] && (hasChildren(getObjectValue(row, childrenColumnName)) || getObjectValue(row, hasChildrenColumnName))) {
            expandIcon = expandedState === 'loading' ? /*#__PURE__*/React.createElement(Loading, {
              className: "jmtd-table-plugin-table-loading",
              size: "mini",
              loading: true
            }) : /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref4) {
              var _ref4$tableExpandIcon = _ref4.tableExpandIcon,
                  tableExpandIcon = _ref4$tableExpandIcon === void 0 ? 'jmti-plus-circle-f' : _ref4$tableExpandIcon,
                  _ref4$tableShrinkIcon = _ref4.tableShrinkIcon,
                  tableShrinkIcon = _ref4$tableShrinkIcon === void 0 ? 'jmti-minus-circle-f' : _ref4$tableShrinkIcon;
              return /*#__PURE__*/React.createElement(Icon, {
                "data-event-name": expandedState ? 'shrink' : 'expand',
                className: classNames(expandedState ? tableShrinkIcon : tableExpandIcon, 'jmtd-table-plugin-tree-expand-icon'),
                onClick: function onClick() {
                  change('treeExpand', row);
                }
              });
            }); // 设置图标缩进

            if (level > 0) {
              iconIndent = Indent(level * (iconWidth + 10));
            }
          }

          return /*#__PURE__*/React.createElement("div", {
            className: "jmti-table-plugin-tree-cell-wrap"
          }, iconIndent, expandIcon && /*#__PURE__*/React.createElement("div", {
            className: "jmti-table-plugin-tree-icon-wrap",
            style: {
              width: iconWidth,
              height: iconWidth
            }
          }, expandIcon), Indent(level == null ? 0 : iconIndent ? 10 : (level + 1) * (iconWidth + 10) - (expandIcon ? iconWidth : 0)), /*#__PURE__*/React.createElement("span", {
            className: "jmti-table-plugin-tree-cell-content"
          }, td));
        });
      }

      return {};
    })
  };
}